import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  categoryName: string;
  categorySlug: string;
  excerpt: string;
  author: string;
  date: string;
  readTime: string;
  image: string;
}

export default function ArticleCard({
  slug,
  title,
  categoryName,
  categorySlug,
  excerpt,
  author,
  date,
  readTime,
  image,
}: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300">
      <Link to={`/article/${slug}`} className="block cursor-pointer">
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      </Link>
      <div className="p-5">
        <Link
          to={`/category/${categorySlug}`}
          className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3 hover:bg-accent-200 transition-colors cursor-pointer whitespace-nowrap"
        >
          {categoryName}
        </Link>
        <Link to={`/article/${slug}`} className="block cursor-pointer">
          <h3 className="font-heading text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
            {title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed mb-4">
          {excerpt}
        </p>
        <div className="flex items-center gap-3 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-user-line"></i>
            {author}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {readTime}
          </span>
        </div>
      </div>
    </article>
  );
}